// see https://plonerestapi.readthedocs.io/en/latest/endpoints/users.html?highlight=reset#reset-user-password
// react core
import React from 'react';
import { useState } from 'react';
import ErrorMessage from 'components/commons/error_msg';
import { Link } from "react-router-dom";

// components
import UserLogged from 'components/commons/user_logged';
import IsEmailValidator from 'components/commons/is_email_validator';
import AjaxSpinner from 'components/commons/ajax_spinner';

// libs
import { AUTH } from 'api/account';
import { check_if_email } from 'utils/helpers';
import { route_to_full_url } from 'utils/helpers';
import usePageTitle from 'utils/page_title';

function ButtonSender({ username, on_click })
{
    if (username.length > 6 && check_if_email(username))
    {
        return (
            <button onClick={on_click} className="button button-primary">Start Password Reset</button>
        )
    }
    else
    {
        return (
            <button disabled className="button button-primary">Start Password Reset</button>
        )
    }
}

export default function ForgotPasswordPage({ user })
{
    usePageTitle('Forgot Your Password');
    // default data
    const [username, set_username] = useState('');
    const [is_submitted, set_is_submitted] = useState(false);
    const [errors, set_errors] = useState(false);
    const [is_await, set_is_await] = useState(false);
    // send credentials
    const handle_submit = (evt) =>
    {
        evt.stopPropagation();
        evt.preventDefault();
        const send_data = async () =>
        {
            const response = await AUTH.lost_password(username);
            if (response.ok)
            {
                set_is_submitted(true);
                set_errors(false);
                set_username('');
                set_is_await(false);
            }
            else
            {
                set_username('');
                set_errors(true);
                set_is_await(false);
            }
        }
        // call the function
        set_is_await(true);
        send_data().catch(console.error);
    };
    if (user.ok === true && user.username !== '')
    {
        return (
            <UserLogged />
        )
    }
    else
    {
        if(is_submitted) return (
            <>
            <h2>Forgot your password?</h2>
            <div className='confirm-message'>
                <div>
                    <strong>Almost there!</strong>
                    <span>Check your email box and follow the link to reset your password.</span>
                </div>
            </div>
            </>
        );
        else
        {
            let classess = (errors) ? 'auth-form error' : 'auth-form';
            classess += is_await ? ' loading' : '';
            const error_msg = 'Sorry, there was an error. Please try again later or contact the support.';
            return (
                <>
                    <h2>Forgot your password?</h2>
                    <p>
                        If you would like to reset your password, fill out the form below and we will send you an email
                        to start the process of resetting your password.
                    </p>
                    <AjaxSpinner show={is_await} />
                    <form action="#" className={classess}>
                        <div className="auth-form-errors">
                            <i className="fa-solid fa-circle-exclamation"></i>
                            <ErrorMessage display={errors} msg={error_msg} />
                        </div>
                        <fieldset>
                            <div className="auth-form-field">
                                <input
                                    name="username"
                                    id="forgot-form-username"
                                    type="text"
                                    required
                                    autoComplete="username"
                                    value={username}
                                    placeholder="Your business email address"
                                    onChange={(e) => set_username(e.target.value)}
                                />
                                <label htmlFor="forgot-form-username">
                                    Your business email address <IsEmailValidator username={username} />
                                </label>
                            </div>
                        </fieldset>
                        <div className="auth-form-buttons">
                            <ButtonSender username={username} on_click={handle_submit} />
                        </div>
                    </form>

                    <p>Found your password? <Link className='primary' to={route_to_full_url("login")}>Log in here</Link></p>
                </>
            );
        }
    }
};
